<template>
  <modal name="login-user" height="auto" :scrollable="true">
    <button
      @click="hide('login-user')"
      style="margin:5% 5%; cursor:pointer"
      class="pull-right"
    >
      <span class="mdi mdi-alpha-x-circle"></span>
    </button>
    <div style="margin-top:5%;" class="form-group col-8">
      <h4 style="color:black">{{ message }}</h4>
    </div>
    <div
      v-if="error !== ''"
      style="margin-top:5%;"
      class="alert alert-danger text-center col-6 offset-3"
    >
      {{ error }}
    </div>
    <div class="loader" v-if="loader"></div>
    <div class="login-form col-10" style="margin:5%;">
      <h2>{{ $t("auth.login") }}</h2>
      <form method="post" @submit.prevent="login" v-if="!success">
        <div
          class="group-input"
          v-bind:class="{ 'has-error': has_error && errors.email }"
        >
          <label
            for="username"
            v-bind:class="{
              'text-danger': has_error && errors.email,
            }"
            >{{ $t("attr.email") }} *</label
          >
          <input type="text" id="email" v-model="email" />
          <span
            class="text-danger help-block"
            v-if="has_error && errors.email"
            >{{ errors.email[0] }}</span
          >
        </div>
        <div
          class="group-input"
          v-bind:class="{ 'has-error': has_error && errors.password }"
        >
          <label
            for="password"
            v-bind:class="{
              'text-danger': has_error && errors.password,
            }"
            >{{ $t("attr.password") }} *</label
          >
          <input
            type="password"
            id="password"
            v-model="password"
            v-bind:class="{
              'is-invalid': has_error && errors.password,
            }"
          />
          <span
            class="help-block text-danger"
            v-if="has_error && errors.password"
            >{{ errors.password[0] }}</span
          >
        </div>
        <div class="group-input gi-check">
          <div class="gi-more">
            <label for="save-pass">
              {{ $t("action.save") }} {{ $t("attr.password") }}
              <input type="checkbox" id="save-pass" />
              <span class="checkmark"></span>
            </label>

            <router-link :to="{ name: 'forgot' }" class="forget-pass">{{
              $t("auth.forget-password")
            }}</router-link>
          </div>
        </div>
        <button type="submit" class="btn-site btn-login">
          {{ $t("auth.sign-in") }}
        </button>
      </form>
      <div class="switch-login">
        <router-link :to="{ name: 'register' }" class="or-login">
          {{ $t("general.or") }} {{ $t("action.create") }}
          {{ $t("general.an") }} {{ $t("auth.account") }}
        </router-link>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    route: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      name: "",
      email: "",
      password: "",
      password_confirmation: "",
      has_error: false,
      error: "",
      errors: {},
      success: false,
      loader: false,
      message: "",
      regEmail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  methods: {
    hide(modalName) {
      this.$modal.hide(modalName);
    },
    login() {
      var app = this;
      let email = this.email;
      let password = this.password;
      let data = {};

      if (!app.regEmail.test(email)) {
        data = {
          username: email,
          password,
        };
      } else {
        data = {
          email,
          password,
        };
      }

      app.loader = true;
      this.$store
        .dispatch("login", data)
        .then((response) => {
          app.user = response.data.data.user;
          app.notifications = response.data.data.notifications;
          app.loader = false;
          app.hide("login-user");
          window.location.reload();
        })
        .catch(function(err) {
          app.has_error = true;
          app.error = app.$t(err.response.data.message);
          app.errors = err.response.data.data || {};
          app.loader = false;
        });
    },
  },
  computed: {
    tokenExpiryDate: {
      get() {
        return this.$store.state.tokenExpiryDate;
      },
      set(expiryDate) {
        this.$store.commit("set_token_expiry_date", { expiryDate: expiryDate });
      },
    },
    user: {
      get() {
        return this.$store.state.user;
      },
      set(user) {
        this.$store.commit("setUser", { user: user });
      },
    },
    notifications: {
      get() {
        return this.$store.state.notifications;
      },
      set(notifications) {
        this.$store.commit("setNotifications", {
          notifications: notifications,
        });
      },
    },
  },
};
</script>
